<template>
  <div>
    <sweet-modal ref="modal" width="450px" hide-close-button blocking>
      <p class="font-weight-bold">{{ type }}</p>
      <span class="text d-block mb-4">{{ text }}</span>

      <div class="ba-flex ba-w-100 ba-ai-center ba-jc-fe ba-gp-08">
        <button @click="cancel()" class="ba-btn ba-md ba-light">
          {{ this.$t("ct-cancel") }}
        </button>
        <button @click="confirm()" class="ba-btn ba-md ba-blue">
          {{ this.$t("ct-confirm") }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
export default {
  props: ["text", "show", "type"],
  name: "ModalConfirmComponent",
  components: {
    SweetModal,
  },
  watch: {
    show: function (value) {
      if (value) this.$refs.modal.open();
      else this.$refs.modal.close();
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },

    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalConfirm.vue